// extracted by mini-css-extract-plugin
export default {"outerCircle":"CircleCustomIcon_outerCircle__CsIHA","innerCircle":"CircleCustomIcon_innerCircle__2CRc1"};